import { Card, Grid, Typography } from "@material-ui/core";
import MainContainer from "./containers/MainContainer";
import TopBar from "./containers/TopBar";

import Global from "../assets/css/style";
import {
  dateFormat,
  permuteCount,
  datePhpFormat2,
  datePerTime,
} from "../utils/functions";

import CheckCircleIcon from "@material-ui/icons/CheckCircle";

const DesignEachNumber = ({ eachSlip, eachSlipKey, type }) => {
  const bgStyle =
    eachSlip.prize_amount > 0
      ? { backgroundColor: "green" }
      : { backgroundColor: "transparent" };
  const fontStyle = eachSlip.prize_amount > 0 ? "#fff" : Global.color;
  const fontStyle2 = eachSlip.prize_amount > 0 ? "#fff" : "#6D6D6D";
  return (
    <div className="number-container" key={eachSlipKey} style={bgStyle}>
      <Grid container className="per-number">
        <Grid
          item
          xs={6}
          container
          style={{
            flexDirection: "column",
          }}
        >
          <Grid item>
            <Typography
              style={{
                color: fontStyle,
                padding: 10,
                paddingLeft: 20,
                fontWeight: "bold",
              }}
            >
              {eachSlip.slip}
              <span
                style={{
                  fontStyle: "italic",
                  color: "#789",
                  display: "inline-block",
                  marginLeft: 4,
                  fontSize: 14,
                }}
              >
                {datePhpFormat2(eachSlip.date)}
              </span>
              {eachSlip.prize_amount > 0 ? (
                <span
                  style={{
                    fontStyle: "italic",
                    display: "inline-block",
                    marginLeft: 4,
                    fontSize: 14,
                  }}
                >
                  Win
                </span>
              ) : null}
            </Typography>
          </Grid>
          <Grid item>
            {type === "System Entry" || type === "iBet" ? (
              <Grid item>
                <Typography
                  style={{
                    color: fontStyle,
                    fontSize: 12,
                    marginTop: -12,
                    paddingLeft: 20,
                  }}
                >
                  {permuteCount(eachSlip.slip.split(""))} Permutations
                </Typography>
              </Grid>
            ) : null}
          </Grid>
        </Grid>
        <Grid item xs={3}>
          <Typography
            style={{
              color: fontStyle2,
              padding: 10,
              fontWeight: "bold",
            }}
          >
            {eachSlip.big}
          </Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography
            style={{
              color: fontStyle2,
              padding: 10,
              fontWeight: "bold",
            }}
          >
            {eachSlip.small}
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
};

const DateTitle = ({ f_date }) => (
  <>
    <Grid item container>
      <Grid item xs={9}>
        <Typography
          variant="h5"
          style={{
            textTransform: "uppercase",
            fontSize: 18,
            fontWeight: "bold",
          }}
        >
          Draw Date
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography
          variant="h5"
          style={{
            textTransform: "uppercase",
            fontSize: 18,
            fontWeight: "bold",
          }}
        >
          Draw No.
        </Typography>
      </Grid>
    </Grid>
    {f_date?.map((eachDate, eachDateCtr) => (
      <Grid item container key={eachDateCtr}>
        <Grid item xs={9}>
          <Typography>{datePerTime(eachDate.date)}</Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography>{eachDate.no}</Typography>
        </Grid>
      </Grid>
    ))}
  </>
);

const CardBookingSpecific2 = ({
  bet,
  children,
  leftSide = "",
  e_date = false,
}) => {
  return (
    <MainContainer
      render={
        <Grid container direction="column">
          <TopBar title="Bet Receipt" rightSide="" leftSide={leftSide}>
            <Grid container style={{ textAlign: "center" }}>
              <Grid item xs={12}>
                <Typography
                  variant="h5"
                  style={{
                    marginTop: 5,
                    fontStyle: "italic",
                    fontSize: 18,
                    textTransform: "uppercase",
                  }}
                >
                  {bet.bookNo}
                </Typography>
                <Typography style={{ marginTop: 5, fontSize: 16 }}>
                  Bet(s) successfully placed on
                  <br />
                  {dateFormat("d M Y h:i A", bet.created_at).toUpperCase()}
                </Typography>
                <CheckCircleIcon
                  style={{
                    color: "green",
                    backgroundColor: "#fff",
                    borderRadius: "50%",
                    fontSize: 70,
                    position: "relative",
                    zIndex: 1,
                  }}
                />
              </Grid>
            </Grid>
          </TopBar>
        </Grid>
      }
      style={{ height: 170 }}
    >
      {bet.game === "4d"
        ? bet.data.map((eachBet, eachBetKey) => (
            <div
              key={eachBetKey}
              style={{
                borderBottom: "1px solid #222",
                paddingBottom: 10,
              }}
            >
              {/* <pre>{JSON.stringify(eachBet, null, 2)}</pre> */}
              <DateTitle f_date={eachBet.dates} />
              <Grid container style={{ marginTop: 10 }}>
                <Grid item xs={6} style={{ marginTop: 10 }}>
                  <Typography
                    variant="h5"
                    style={{
                      textTransform: "uppercase",
                      fontSize: 18,
                      fontWeight: "bold",
                    }}
                  >
                    {eachBet.type}
                  </Typography>
                  <Typography>{eachBet.slip.length} Board(s)</Typography>
                </Grid>
              </Grid>
              <Card
                style={{
                  backgroundColor: "#F7F7F7",
                  position: "relative",
                  borderRadius: 16,
                  marginTop: 10,
                  marginBottom: 10,
                }}
              >
                <Grid
                  container
                  style={{
                    backgroundColor: Global.color,
                    opacity: 1,
                    color: "#fff",
                  }}
                >
                  <Grid item xs={6}></Grid>
                  <Grid item xs={3}>
                    <Typography
                      variant="subtitle1"
                      style={{
                        fontSize: 12,
                        padding: 10,
                        textTransform: "uppercase",
                      }}
                    >
                      Big
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Typography
                      variant="subtitle1"
                      style={{
                        fontSize: 12,
                        padding: 10,
                        textTransform: "uppercase",
                      }}
                    >
                      Small
                    </Typography>
                  </Grid>
                </Grid>
                {eachBet.slip.map((eachSlip, eachSlipKey) => (
                  <DesignEachNumber
                    key={eachSlipKey}
                    eachSlip={eachSlip}
                    eachSlipKey={eachSlipKey}
                    type={eachBet.type}
                  />
                ))}
              </Card>
              <Grid container style={{ marginTop: 20 }}>
                <Grid item xs={9}>
                  <Typography
                    variant="h5"
                    style={{
                      fontWeight: "bold",
                      color: "#6d6d6d",
                      fontSize: 18,
                    }}
                  >
                    Subtotal:
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography
                    style={{
                      fontWeight: "bold",
                      color: "#6d6d6d",
                      fontSize: 17,
                    }}
                  >
                    ${eachBet.subTotal.toFixed(2)}
                  </Typography>
                </Grid>
              </Grid>
            </div>
          ))
        : null}

      {/* <pre>{JSON.stringify(bet, null, 4)}</pre> */}

      {bet.game === "toto"
        ? bet.data?.map((eachBet, eachBetKey) => (
            <div
              key={eachBetKey}
              style={{
                borderBottom: "1px solid #222",
                paddingBottom: 10,
              }}
            >
              <DateTitle f_date={eachBet.dates} />
              <Grid container style={{ marginTop: 10 }}>
                <Grid item xs={6} style={{ marginTop: 10 }}>
                  <Typography
                    variant="h5"
                    style={{
                      textTransform: "uppercase",
                      fontSize: 18,
                      fontWeight: "bold",
                    }}
                  >
                    {eachBet.type}
                  </Typography>
                  <Typography>{eachBet.slip.length} Board(s)</Typography>
                </Grid>
              </Grid>

              <Grid item>
                <Card
                  style={{
                    backgroundColor: "#F7F7F7",
                    position: "relative",
                    borderRadius: 16,
                    marginTop: 10,
                  }}
                >
                  {eachBet.slip.map((b, bI) => {
                    return (
                      <div
                        key={bI}
                        style={{
                          background: parseInt(b.win) > 0 ? "green" : "#fff",
                          color: parseInt(b.win) > 0 ? "#fff" : Global.color,
                          borderBottom: "1px solid #ddd",
                          textAlign: "center",
                        }}
                      >
                        <div
                          style={{
                            marginBottom: -20,
                            fontFamily: "arial",
                            fontStyle: "italic",
                            paddingTop: 2,
                          }}
                        >
                          {dateFormat("d M Y", b.date)}
                        </div>
                        {b.slip.split(",").map((c, cI) => {
                          return (
                            <Typography
                              key={cI}
                              style={{
                                padding: 10,
                                fontWeight: "bold",

                                paddingTop: 18,
                                display: "inline-block",
                                textAlign: "center",
                                width: 30,
                                marginLeft: 1,
                                fontSize: 20,
                              }}
                            >
                              {c}
                            </Typography>
                          );
                        })}
                      </div>
                    );
                  })}
                </Card>
              </Grid>

              <Grid container style={{ marginTop: 20 }}>
                <Grid item xs={9}>
                  <Typography
                    variant="h5"
                    style={{
                      fontWeight: "bold",
                      color: "#6d6d6d",
                      fontSize: 18,
                    }}
                  >
                    Subtotal:
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography
                    style={{
                      fontWeight: "bold",
                      color: "#6d6d6d",
                      fontSize: 17,
                    }}
                  >
                    ${eachBet.subTotal.toFixed(2)}
                  </Typography>
                </Grid>
              </Grid>
            </div>
          ))
        : null}

      <Grid
        container
        style={{
          padding: 20,
          paddingLeft: 0,
          paddingRight: 0,
          backgroundColor: "#e7e7e7",
          marginLeft: -16,
          width: "calc(100% + 30px)",
          borderTop: "0.5px solid #C4C4C4",
          borderBottom: "0.5px solid #C4C4C4",
          marginTop: 16,
        }}
      >
        <Grid item xs={9}>
          <Typography
            variant="h5"
            style={{
              fontWeight: "bold",
              color: "#6d6d6d",
              fontSize: 24,
              paddingLeft: 16,
            }}
          >
            Total Stake:
          </Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography
            style={{
              fontWeight: "bold",
              color: "#6d6d6d",
              fontSize: 23,
            }}
          >
            ${bet.total?.toFixed(2)}
          </Typography>
        </Grid>
      </Grid>
      {children}
    </MainContainer>
  );
};

export default CardBookingSpecific2;
